export default "__VITE_ASSET__Cc$RsB9O__"